import {
  ColSize,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createKorNumberCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import TableRowStatusBadge from '@/src/components/molecule/TableRowStatusBadge';

export const partnershipCompaniesListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createTypoCol({
    field: 'name',
    size: 'md',
    headerName: '제휴사 명',
  }),
  createKorNumberCol({
    field: 'phone',
    size: 'md',
    headerName: '대표 전화번호',
  }),
  createTypoCol({
    field: 'email',
    size: 'md',
    headerName: '대표 이메일',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'lg',
    headerName: '등록 일자',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'isUsing',
    ...ColSize.sm,
    cellRenderer: (params: ValueGetterParams) => {
      return (
        <TableRowStatusBadge type="isActivated" value={params.data?.isUsing} />
      );
    },
    headerName: '사용 여부',
  },
  createDetailButtonColV2(onDetailClick),
];
